import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: process.env.VUE_APP_SERVER_URL,
    timeout: 15000,
    headers: {
      authorization: `Bearer ${process.env.VUE_APP_EVENT_TRACKING_PAGE_TOKEN}`
    }
  })
}

const logApi = {
  postLog: (request) => {
    const { body, config = {} } = request
    return instance().post(`api/log`, body, {
      ...config
    })
  }
}

export default logApi
